import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { getBasePath } from 'utils/basePath';

import { BRAND } from '@/brand/config';

import cacheBursting from '../../i18n-translations-hash.json';

i18n
	// load translation using http -> see /public/locales
	.use(Backend)
	// detect user language
	.use(LanguageDetector)
	// pass the i18n instance to react-i18next.
	.use(initReactI18next)
	// init i18next
	.init({
		debug: false,
		fallbackLng: 'en',
		interpolation: {
			escapeValue: false, // not needed for react as it escapes by default
			// Every translated string spells the product name as {{brand}}, so
			// renaming the company stays a configuration change. Supplied here
			// rather than at each t() call site: a caller who forgets would
			// render the placeholder to a customer.
			defaultVariables: { brand: BRAND.name },
		},
		backend: {
			loadPath: (languages: string[], namespaces: string[]): string => {
				const language = languages[0];
				const namespace = namespaces[0];
				const pathkey = `/${language}/${namespace}`;
				const hash = cacheBursting[pathkey as keyof typeof cacheBursting] || '';
				return `${getBasePath()}locales/${language}/${namespace}.json?h=${hash}`;
			},
		},
		react: {
			useSuspense: false,
		},
	});

export default i18n;
